
import { Component, Mixins } from 'vue-property-decorator';
import { getHotGameTypeList, delHotGameType, setHotGameTypeSort } from '@/api/hot-game-type';
import HotGameType from './edit.vue';
import { toast } from '@/utils/common';
import { iHotTypeGameSearch, iHotTypeGame, iHotGameTypeSort, eEndPoint } from '@/interface/hot-game';
import { PageQuery } from '@/mixins/page_query';
@Component({
  components: { HotGameType },
  filters: {
    getCategoryLabel(_val: number) {
      const item = [
        {
          label: '不关联',
          val: 0,
        },
        {
          label: '类别1',
          val: 1,
        },
        {
          label: '类别2',
          val: 2,
        },
        {
          label: '类别3',
          val: 3,
        },
      ].find(item => item.val === _val);
      return item ? item.label : '无';
    },
  },
})
export default class HotGame extends Mixins(PageQuery) {
  detailsTable: iHotTypeGame[] = [];
  loading: boolean = false;
  typeVisible: boolean = false;
  endpoint: eEndPoint = 0;
  model: iHotTypeGame = {
    id: 0,
    title: '',
    endpoint: this.endpoint,
  };

  ActFree: number = -1;
  total: number = 0;
  exitTitle: string = '新增';
  searchInfo: iHotTypeGameSearch = {
    search: '',
    endpoint: this.endpoint,
  };

  /* 查询 */
  searchList() {
    // this.page_query.page = 1;
    this.getList();
  }
  /* 编辑 */
  editRow(row: iHotTypeGame) {
    this.clear();
    this.typeVisible = true;
    this.model = row;
    this.exitTitle = '编辑';
  }
  addHotGame() {
    this.clear();
    this.typeVisible = true;
    this.exitTitle = '新增';
  }

  async getList() {
    this.loading = true;
    try {
      const query = {
        page: this.page_query.page,
        size: this.page_query.page_size,
        ...this.searchInfo,
      };
      const res = await getHotGameTypeList(query);
      if (res && res.code == 0) {
        this.detailsTable = res.data.kinds;
        this.total = res.data.total;
        this.loading = false;
      }
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  }
  /* 排序 */
  async upSort(row: any, sort: string) {
    let sortItem: iHotGameTypeSort = {
      id: row.id || -1,
      sort: sort,
      version: row.version || -1,
    };
    try {
      const res = await setHotGameTypeSort(sortItem);
      if (res && res.code == 0) {
        toast('操作成功!请到游戏入口的TAB页签，客户端显示不会马上生效，点击游戏入口配置页面的发布，确认后客户端显示生效');

        this.loading = false;
        this.searchList();
      }
    } catch (err) {
      this.loading = false;
      console.log(err);
      if (err && err.code == 3) {
        this.searchList();
      }
    }
  }
  /* 删除 */
  async removeRow(row: any) {
    if (row.id == 1) {
      toast('第一条数据不能删除', 'error');
      return;
    }
    this.$msgbox({
      title: '提示',
      message: '是否确认删除，删除后，需要发布才能生效!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          this.loading = true;
          const obj = { id: row.id, version: row.version };
          const res: any = await delHotGameType(obj);
          done();
          if (res && res.code == 0) {
            toast('操作成功');
            this.loading = false;
            toast('请到游戏入口的TAB页签，客户端显示不会马上生效，点击游戏入口配置页面的发布，确认后客户端显示生效');

            this.searchList();
          }
          instance.confirmButtonLoading = false;
          this.loading = false;
        } else if (action === 'cancel') {
          //    alert(action);
          done();
          instance.confirmButtonLoading = false;
          this.loading = false;
        }
      },
    })
      .then(() => {})
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  clear() {
    this.model = {
      id: 0,
      title: '',
      endpoint: this.endpoint,
    };
  }
  editOk() {
    this.clear();
    this.getList();
    this.typeVisible = false;
  }

  goback() {
    this.$router.push('hot-game');
  }
  mounted() {
    this.endpoint = this.$route.meta!.type;
    this.model.endpoint = this.endpoint;
    this.searchInfo.endpoint = this.endpoint;
    this.pageFn = this.searchList;
    this.searchList();
  }
}
